import type { ReactNode } from "react";

type OccupancyLegendRowProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

// One entry of the occupancy legend: what an icon or map marker looks like, and what it means
export const OccupancyLegendRow = ({ icon, title, description }: OccupancyLegendRowProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        {icon}
        <h4 className="text-[15px] font-semibold leading-5">{title}</h4>
      </div>
      <p>{description}</p>
    </div>
  );
};
